var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useState, useContext, useMemo, useCallback } from 'react';
import { ConfirmModal } from 'react-bootstrap4-modal';
import useModal from './useModal';
import ErrorDisplay from './ErrorDisplay';
function defaultConfirm() {
    // Confirm does nothing by default
}
defaultConfirm.visible = false;
const ConfirmContext = createContext(defaultConfirm);
function Confirm({ children }) {
    var _a, _b, _c, _d;
    const [actionInProgress, setActionInProgress] = useState(false);
    const modal = useModal();
    const okClicked = () => __awaiter(this, void 0, void 0, function* () {
        var _e;
        setActionInProgress(true);
        try {
            yield ((_e = modal.state) === null || _e === void 0 ? void 0 : _e.action());
            modal.close();
        }
        catch (error) {
            if (modal.state && modal.state.onError) {
                modal.state.onError(error);
            }
            if (modal.state && modal.state.renderError) {
                modal.setState(Object.assign(Object.assign({}, modal.state), { error }));
            }
            if (!modal.state || (!modal.state.onError && !modal.state.renderError)) {
                throw error;
            }
        }
        finally {
            setActionInProgress(false);
        }
    });
    const contextValue = useMemo(() => {
        const augmentedConfirm = (state) => modal.open(state);
        augmentedConfirm.visible = modal.visible;
        return augmentedConfirm;
    }, [modal]);
    const cancelClicked = useCallback(() => {
        var _a, _b;
        if ((_a = modal.state) === null || _a === void 0 ? void 0 : _a.onCancel) {
            (_b = modal.state) === null || _b === void 0 ? void 0 : _b.onCancel();
        }
        modal.close();
    }, [modal]);
    return (_jsxs(ConfirmContext.Provider, Object.assign({ value: contextValue }, { children: [children, _jsxs(ConfirmModal, Object.assign({ visible: modal.visible, onOK: okClicked, onCancel: cancelClicked, disableButtons: actionInProgress }, { children: [(_b = (_a = modal.state) === null || _a === void 0 ? void 0 : _a.prompt) !== null && _b !== void 0 ? _b : _jsx("div", {}), ((_c = modal.state) === null || _c === void 0 ? void 0 : _c.renderError) && ((_d = modal.state) === null || _d === void 0 ? void 0 : _d.error)
                        ? modal.state.renderError(modal.state.error)
                        : null] }))] })));
}
export function useConfirm() {
    const confirm = useContext(ConfirmContext);
    return confirm;
}
export function useGraphQLConfirm() {
    const confirm = useConfirm();
    const defaultRenderError = useCallback((error) => _jsx(ErrorDisplay, { graphQLError: error }), []);
    const augmentedConfirmWithDefaults = useMemo(() => {
        const confirmWithDefaults = (options) => confirm(Object.assign({ renderError: defaultRenderError }, options));
        confirmWithDefaults.visible = confirm.visible;
        return confirmWithDefaults;
    }, [confirm, defaultRenderError]);
    return augmentedConfirmWithDefaults;
}
function ConfirmTrigger({ children }) {
    const confirm = useConfirm();
    return children(confirm);
}
Confirm.Trigger = ConfirmTrigger;
export default Confirm;
//# sourceMappingURL=Confirm.js.map